import React, { useState } from "react";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarDashboard from "../../../components/SidebarDashboard";

const DashboardOnPowerBI = () => {
  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div class="embed-responsive embed-responsive-16by9">
          <iframe title="Report Section" width="600" height="373.5" src="https://app.powerbi.com/view?r=eyJrIjoiMmM4OTJkOWUtYTgyNC00NTJmLTkwNWItNmI3OTE5M2I5NGYwIiwidCI6ImE4MzVhNGJlLTYwZmMtNDEyMy1hODkzLTExOGFlODQ1NDBkNSJ9" frameborder="0" allowFullScreen="true"></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardOnPowerBI;
